/** Готов ли раздел на портале. `false` — в меню пометка «скоро». */
export const READY = true;
